<template>
  <v-container flex grid-list-lg>
    <template v-if="!smartLock">
      <smart-lock-message></smart-lock-message>
    </template>
    <v-layout row wrap v-else>
      <v-flex xs12>
        <v-toolbar color="#eee" class="elevation-0 secondary--text">
          <v-toolbar-title>Postos</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-slide-x-transition>
            <v-layout justify-end v-show="searchingPosto">
              <v-flex xs1>
                  <v-tooltip bottom>
                    <v-btn
                      icon
                      color="info"
                      @click="carregarPostos(true)"
                      slot="activator"
                    >
                      <v-icon>search</v-icon>
                    </v-btn>
                    <span>Pesquisar</span>
                  </v-tooltip>
                </v-flex>
              <v-flex xs3>
                <v-btn
                  small
                  round
                  @click="statusPostos"
                  :color="ativos === undefined ? '' : ativos ? 'success' : 'error'">
                  Mostrar
                  {{
                    ativos === undefined ? ' todos' : ativos ? ' ativos' : ' desativos'
                  }}
                </v-btn>
              </v-flex>
              <v-flex xs3>
                <v-select
                  outline
                  hide-details
                  single-line
                  placeholder="Filtrar por"
                  :items="filtrosPosto"
                  item-value="value"
                  item-text="text"
                  v-model="filtro"
                ></v-select>
              </v-flex>
              <v-flex xs4 v-if="!filtro || filtro !== 'is_white_label'">
                <v-text-field
                  outline
                  hide-details
                  single-line
                  :placeholder="filtro === 'cnpj' ? 'Insira o CNPJ' : 'Insira as informações'"
                  :mask="filtro === 'cnpj' ? '##.###.###/####-##' : ''"
                  v-model="campoPesquisa"
                ></v-text-field>
              </v-flex>
              <v-flex xs4 v-else>
                <v-checkbox
                  v-model="campoPesquisa"
                  color="primary"
                  class="mt-2"
                  :hide-details="campoPesquisa"
                >
                  <template slot="label">
                    <span class="body-2 grey--text">É White Label</span>
                  </template>
                </v-checkbox>
              </v-flex>
            </v-layout>
          </v-slide-x-transition>
          <transferencia-de-informacoes-posto @transferencia-concluida="transferenciaConcluida"/>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn :disabled="!smartLock" v-on="on" icon color="info" @click="dialogCadCod = true">
                <v-icon>confirmation_number</v-icon>
              </v-btn>
            </template>
            <span>Código promocional</span>
           </v-tooltip>
          <v-btn icon color="info" @click="searchingPosto = !searchingPosto">
            <v-icon v-if="!searchingPosto">search</v-icon>
            <v-icon v-else>close</v-icon>
          </v-btn>
          <v-tooltip bottom>
            <v-btn @click="dialogFirebase = true" slot="activator" color="info" icon>
              <v-icon>local_fire_department</v-icon>
            </v-btn>
            <span>Gerenciar Projetos Firebase</span>
          </v-tooltip>
          <v-tooltip bottom>
            <v-btn @click="dialogContrato = true" slot="activator" color="info" icon>
              <v-icon>description</v-icon>
            </v-btn>
            <span>Contrato Padrão</span>
          </v-tooltip>
          <v-dialog
            v-model="dialog"
            width="600"
            lazy
            :fullscreen="$vuetify.breakpoint.xs"
            hide-overlay
          >
            <v-btn icon color="info" slot="activator">
              <v-icon>add</v-icon>
            </v-btn>
            <cad-posto v-on:fechar="dialog = false" v-on:info="showInfo" v-on:error="showError"></cad-posto>
          </v-dialog>
        </v-toolbar>
      </v-flex>
      <v-flex xs12>
        <v-data-table
          :headers="postoHeaders"
          :items="postos"
          :loading="loading"
          :pagination.sync="pagination"
          :total-items="totalItems"
          hide-actions
        >
          <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
          <template slot="headerCell" slot-scope="{ header }">
            <span class="font-weight-light" v-text="header.text" />
          </template>
          <template slot="items" slot-scope="props">
            <td>{{ props.item.nome_fantasia }}</td>
            <td class="text-xs-left">{{ props.item.razao_social }}</td>
            <td class="text-xs-left">{{ props.item.cnpj }}</td>
            <td
              class="text-xs-left"
              v-html="props.item.representante ? `${props.item.representante.nome} ${props.item.representante.sobrenome}`: `Automação ${props.item.empresa_automacao}` "
            ></td>
            <td class="text-xs-left" v-html="`R$ ${props.item.valor_fatura_mensal}`"></td>
            <td class="text-xs-left">
              <v-btn flat icon v-if="props.item.ativo" color="green lighten-2">
                <v-icon>check_circle</v-icon>ATIVO
              </v-btn>

              <v-btn flat icon v-else color="error">
                <v-icon>cancel</v-icon>INATIVO
              </v-btn>
            </td>
            <td class="text-xs-right">
              <v-tooltip lazy v-if="props.item.ativo" bottom>
                <v-btn icon color="red" slot="activator" flat @click="desativarPosto(props.item)">
                  <v-icon>close</v-icon>
                </v-btn>Desativar Posto
              </v-tooltip>
              <v-tooltip lazy v-else bottom>
                <v-btn icon flat color="green" slot="activator" @click="ativarPosto(props.item)">
                  <v-icon>check</v-icon>
                </v-btn>Ativar Posto
              </v-tooltip>
            </td>
            <td>
              <v-tooltip lazy bottom>
                <v-btn icon flat slot="activator" @click="postoSelecionado = props.item, dialogFrentistas = true">
                  <v-icon>people</v-icon>
                </v-btn>
                Frentistas do posto
              </v-tooltip>
              <v-tooltip lazy bottom>
                <v-btn icon slot="activator">
                  <v-icon color="info" @click="editarPosto(props.item.cnpj)">edit</v-icon>
                </v-btn>Editar Dados
              </v-tooltip>
              <v-tooltip lazy bottom>
                <v-btn slot="activator" flat icon color="primary" @click="detalhesPosto(props.item)">
                  <v-icon>remove_red_eye</v-icon>
                </v-btn>
                Visualizar dados do posto
              </v-tooltip>
              <v-tooltip lazy bottom>
                <v-btn
                  slot="activator"
                  flat
                  icon
                  color="primary"
                  @click="postoSelecionado = props.item, dialogHistorico = true">
                  <v-icon>account_balance_wallet</v-icon>
                </v-btn>
                Visualizar Carteira Virtual
              </v-tooltip>
              <Faturas :postoSelecionado="props.item"/>
            </td>
          </template>
        </v-data-table>
        <div class="text-xs-center pt-2">
          <v-pagination color="info" circle v-model="pagination.page" :length="pages"></v-pagination>
        </div>
      </v-flex>
    </v-layout>
    <v-snackbar
      v-model="snackbar.active"
      :color="snackbar.color"
      :multi-line="snackbar.multiLine"
      :timeout="snackbar.timeout"
      :vertical="snackbar.vertical"
    >
      {{ snackbar.text }}
      <v-btn flat @click="snackbar.active = false">Fechar</v-btn>
    </v-snackbar>
    <v-dialog v-model="dialogContrato" v-if="dialogContrato" width="500" scrollable>
      <contrato-posto @success="showInfo" @error="showError" @fechar="dialogContrato = false"/>
    </v-dialog>
    <v-dialog v-model="dialogFirebase" v-if="dialogFirebase" width="50em" scrollable>
      <dialog-projetos-firebase success="showInfo" @error="showError" @fechar="dialogFirebase = false"/>
    </v-dialog>
    <v-dialog v-model="editandoPosto" width="500" persistent scrollable>
      <edit-posto :cnpj="cnpjPosto" @close="fecharEdicao()" @success="sucessoEdicao()" @error="showError" @editado="showInfo" @carregar="carregarPostos"></edit-posto>
    </v-dialog>
    <v-dialog lazy width="600" v-model="dialogDetalhes" :fullscreen="$vuetify.breakpoint.xs">
      <detalhes-posto :posto="postoSelecionado" @fechar="dialogDetalhes = false"></detalhes-posto>
    </v-dialog>
    <v-dialog v-model="dialogFrentistas" fullscreen hide-overlay transition="dialog-bottom-transition">
        <frentistas-posto v-if="dialogFrentistas" :postoSelecionado="postoSelecionado" @fechar="dialogFrentistas = false"/>
    </v-dialog>
    <v-dialog v-model="dialogCadCod" v-if="dialogCadCod" width="650" :fullscreen="$vuetify.breakpoint.xs">
      <cad-codigo-apetrus @fechar="dialogCadCod = false" @notifications="showInfo" @error="showError"/>
    </v-dialog>
    <v-dialog v-model="dialogHistorico" v-if="dialogHistorico" width="500" scrollable>
      <historico-carteira
        :posto="postoSelecionado"
        @fechar="
          dialogHistorico = false,
          postoSelecionado = undefined
        "
      />
    </v-dialog>
  </v-container>
</template>

<script>
import CadPosto from '@/components/cadastros/CadPosto'
import CadCodigoApetrus from '@/components/cadastros/CadCodigoApetrus'
import EditPosto from '@/components/dialogs/EditPosto'
import DetalhesPosto from '@/components/dialogs/DetalhesPosto'
import FrentistasPosto from '@/components/dialogs/FrentistasPosto'
import SmartLockMessage from '@/components/SmartLockMessage'
import ContratoPosto from '@/components/dialogs/ContratoPosto'
import HistoricoCarteira from '@/components/dialogs/HistoricoCarteira'
import DialogProjetosFirebase from '@/components/dialogs/ProjetosFirebase'
import Faturas from '@/components/dialogs/Faturas'
import TransferenciaDeInformacoesPosto from '@/components/dialogs/TransferenciaDeInformacoesPosto'
import { postoDao } from '@/api'

export default {
  components: {
    CadPosto,
    EditPosto,
    DetalhesPosto,
    SmartLockMessage,
    FrentistasPosto,
    CadCodigoApetrus,
    ContratoPosto,
    HistoricoCarteira,
    DialogProjetosFirebase,
    Faturas,
    TransferenciaDeInformacoesPosto
  },
  data () {
    return {
      dialogContrato: false,
      dialogCadCod: false,
      dialogHistorico: false,
      dialogFirebase: false,
      searchingPosto: false,
      cnpjPosto: null,
      editandoPosto: false,
      postoSelecionado: null,
      dialogDetalhes: false,
      dialogFrentistas: false,
      primeiroCarregamento: false,
      ativos: undefined,
      snackbar: {
        active: false,
        color: '',
        multiLine: true,
        timeout: 4000,
        vertical: true,
        text: ''
      },
      dialogSearchPosto: false,
      dialog: false,
      pagination: {},
      filtro: null,
      campoPesquisa: null,
      filtrosPosto: [
        {
          value: 'cnpj',
          text: 'CNPJ'
        },
        {
          value: 'nome_fantasia',
          text: 'Nome Fantasia'
        },
        {
          value: 'razao_social',
          text: 'Razão Social'
        },
        {
          value: 'is_white_label',
          text: 'White Label'
        }
      ],
      postoHeaders: [
        {
          text: 'Nome Fantasia',
          align: 'left',
          sortable: false,
          value: 'nome_fantasia'
        },
        { text: 'Razão social', sortable: false, value: 'razao_social' },
        { text: 'Cnpj', sortable: false, value: 'cnpj' },
        { text: 'Representante', sortable: false },
        { text: 'Fatura mensal (R$)', sortable: false },
        { text: 'Status', sortable: false, value: 'ativo' },
        {
          sortable: false,
          align: 'right'
        },
        {
          sortable: false,
          align: 'right'
        }
      ]
    }
  },
  computed: {
    smartLock () {
      return this.$store.getters.smartLock
    },
    totalItems () {
      return this.$store.getters.totalItemsPostos
    },
    postos () {
      return this.$store.getters.postos
    },
    loading () {
      return this.$store.getters.loading
    },
    headers () {
      return this.$store.getters.headers
    },
    pages () {
      if (this.pagination.rowsPerPage == null || this.totalItems == null) {
        return 0
      }

      return Math.ceil(this.totalItems / this.pagination.rowsPerPage)
    },
    searchData () {
      let tempData = {
        pagination: this.pagination,
        filtros: {}
      }
      if (this.campoPesquisa) {
        switch (this.filtro) {
          case 'cnpj':
            tempData.filtros['cnpj__icontains'] = this.campoPesquisa
            break
          case 'nome_fantasia':
            tempData.filtros['nome_fantasia__icontains'] = this.campoPesquisa
            break
          case 'razao_social':
            tempData.filtros['razao_social__icontains'] = this.campoPesquisa
            break
          case 'is_white_label':
            tempData.filtros['is_white_label'] = this.campoPesquisa
            break
        }
      }
      if (this.ativos !== undefined) {
        tempData.filtros['ativo'] = this.ativos
      }
      return tempData
    }
  },
  watch: {
    'pagination.page' (val) {
      if (val && this.primeiroCarregamento) {
        this.carregarPostos(false)
      }
    },
    searchingPosto (val) {
      if (!val) {
        this.filtro = null
        this.campoPesquisa = null
      }
    }
  },
  methods: {
    sucessoEdicao () {
      this.editandoPosto = false
      this.carregarPostos(false)
    },
    statusPostos () {
      switch (this.ativos) {
        case undefined:
          this.ativos = true
          break
        case true:
          this.ativos = false
          break
        case false:
          this.ativos = undefined
      }
    },
    editarPosto (cnpj) {
      this.cnpjPosto = cnpj
      this.editandoPosto = true
    },
    fecharEdicao () {
      this.cnpjPosto = null
      this.editandoPosto = false
    },
    desativarPosto (posto) {
      postoDao.desativarPosto(posto.cnpj, this.headers).then(response => {
        if (response.ok) {
          this.carregarPostos(false)
        }
      })
    },
    ativarPosto (posto) {
      postoDao.ativarPosto(posto.cnpj, this.headers).then(response => {
        if (response.ok) {
          this.carregarPostos(false)
        }
      })
    },
    carregarPostos (zerarPaginacao) {
      let tempData = {
        filtros: {}
      }
      if (zerarPaginacao) {
         this.pagination = {
          page: 1,
          rowsPerPage: this.pagination.rowsPerPage
        }
      }
      tempData.pagination = this.pagination
      if (this.campoPesquisa) {
        switch (this.filtro) {
          case 'cnpj':
            tempData.filtros['cnpj__icontains'] = this.campoPesquisa
            break
          case 'nome_fantasia':
            tempData.filtros['nome_fantasia__icontains'] = this.campoPesquisa
            break
          case 'razao_social':
            tempData.filtros['razao_social__icontains'] = this.campoPesquisa
            break
          case 'is_white_label':
            tempData.filtros['is_white_label'] = this.campoPesquisa
            break
        }
      }
      if (this.ativos !== undefined) {
        tempData.filtros['ativo'] = this.ativos
      }
      this.$store.dispatch('carregarPostos', tempData).then(() => {
        this.primeiroCarregamento = true
      })
    },
    showInfo (info) {
      this.snackbar.color = 'info'
      this.snackbar.text = info
      this.snackbar.active = true
      this.carregarPostos(false)
    },
    showError (error) {
      this.snackbar.color = 'error'
      this.snackbar.text = error
      this.snackbar.active = true
    },
    detalhesPosto (posto) {
      this.postoSelecionado = posto
      this.dialogDetalhes = true
    },
    transferenciaConcluida () {
      this.showInfo('Transferência de informações concluída com sucesso')
      this.carregarPostos(false)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
